import * as React from "react";
import { SVGProps } from "react";
function SvgDownloadIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 8h10V6H7v2Zm4.675 12H3V2h18v8.7a7.173 7.173 0 0 0-1.462-.525A6.643 6.643 0 0 0 18 10c-.183 0-.354.004-.512.012-.159.009-.321.03-.488.063V10H7v2h6.125a6.616 6.616 0 0 0-1.45 2H7v2h4.075c-.033.167-.054.33-.063.488-.008.158-.012.329-.012.512 0 .55.05 1.063.15 1.538.1.475.275.962.525 1.462Z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.464 13.464c.979-.978 2.157-1.467 3.535-1.467 1.38 0 2.558.49 3.537 1.467.978.979 1.467 2.157 1.467 3.537 0 1.378-.49 2.556-1.468 3.534-.978.979-2.156 1.468-3.535 1.468s-2.557-.49-3.536-1.468c-.978-.978-1.467-2.156-1.468-3.535.001-1.379.49-2.557 1.468-3.536Zm3.041.495v3.96l-1.626-1.626-.707.707L18 19.828 20.828 17l-.707-.707-1.626 1.626v-3.96h-.99Z"
        fill="#000"
      />
    </svg>
  );
}
export default SvgDownloadIcon;
